export const CHECKOUT_URL = 'https://boxeo-ya.impultienda.ar/checkout'

export const PRODUCT_PRICE_ARS = 18990

export const pains = [
  'Sombra, saco, manoplas, físico… y otra vez lo mismo la clase siguiente.',
  'Alumnos que vienen motivados, pero dejan de ir a las pocas semanas porque no ven progreso real.',
  'Ves que el alumno comete un error, pero te cuesta explicarle cómo corregirlo de forma simple.',
  'Querés cobrar mejor tus clases, pero te falta una estructura que justifique el aumento.',
]

export type Tomo = {
  numero: string
  titulo: string
  bajada: string
}

export const tomos: Tomo[] = [
  { numero: '01', titulo: 'Fundamentos y Biomecánica', bajada: 'La base de todo: guardia, ejes, apoyos y transferencia de fuerza.' },
  { numero: '02', titulo: 'Técnica de Golpes', bajada: 'Potencia y precisión en cada golpe, con progresiones enseñables.' },
  { numero: '03', titulo: 'Defensa y Contraataques', bajada: 'Boxeo inteligente: leer, esquivar y responder en el mismo tiempo.' },
  { numero: '04', titulo: 'Preparación Física', bajada: 'El motor del boxeador: resistencia, fuerza y trabajo por intervalos.' },
  { numero: '05', titulo: 'Estrategia y Combate', bajada: 'Lectura del rival, distancias y planes de pelea aplicables al sparring.' },
  { numero: '06', titulo: 'Planificación y Mentalidad', bajada: 'Orden y autoridad: ciclos, objetivos y liderazgo frente al grupo.' },
]

export type Bono = {
  titulo: string
  beneficio: string
}

export const bonos: Bono[] = [
  { titulo: 'Planillas de Planificación', beneficio: 'Ahorrá horas de preparación antes de cada clase.' },
  { titulo: 'Banco de +100 Ejercicios', beneficio: 'Variedad infinita para que ninguna clase se repita.' },
  { titulo: 'Guía de Corrección por Niveles', beneficio: 'Detectá el error y corregí como un profesional.' },
  { titulo: 'Sistema de Evaluación y Seguimiento', beneficio: 'Hacé que tus alumnos vean su propio progreso.' },
  { titulo: 'Diario del Boxeador Disciplinado', beneficio: 'PDF listo para imprimir y entregar a tus alumnos.' },
]

export type Faq = {
  pregunta: string
  respuesta: string
}

export const faqs: Faq[] = [
  {
    pregunta: '¿Es apto para boxeo recreativo o competitivo?',
    respuesta: 'Ambos. El método se adapta a cualquier alumno que quiera aprender técnica real, desde el que entra por salud hasta el que pelea.',
  },
  {
    pregunta: '¿Cómo recibo el material?',
    respuesta: 'Acceso inmediato a tu email después del pago. Formato digital PDF para leer en celular, tablet o imprimir.',
  },
  {
    pregunta: '¿Tengo que ser un experto para entenderlo?',
    respuesta: 'Al contrario: está escrito de forma simple para que puedas bajar la información a tus alumnos hoy mismo.',
  },
]
